import WHITE_CHEVRON from "../images/Chevron-white.svg";
import WHITE_RETURN from "../images/Return-white.svg";
import WHITE_BOULDER from "../images/White-Boulder.svg";

export const preloadImages = () => {
  const WhiteChevron = new Image();
  WhiteChevron.src = WHITE_CHEVRON;

  const WhiteReturn = new Image();
  WhiteReturn.src = WHITE_RETURN;

  const WhiteBoulder = new Image();
  WhiteBoulder.src = WHITE_BOULDER;
};
